import { useEffect, useState } from 'react'
import { useFormikContext } from 'formik'
import { useNavigate, useParams } from 'react-router-dom'
import { Button } from '@mui/material'

import { ButtonProgress, HelperWrapper, MobileBottomLayout } from 'src/components'
import { maxProgressSteps, minProgressSteps } from './form-addition.component'
import { ROUTES } from 'src/constants'
import { joinAbsRoute } from 'src/common/utils'

import useStyles from '../styles'

interface IMobileAdditionButtonsProps {
  handlePrevStep: () => void
  handleNextStep: () => void
  activeStep: number
}

const MobileAdditionButtons = ({
  handleNextStep,
  handlePrevStep,
  activeStep,
}: IMobileAdditionButtonsProps) => {
  const navigate = useNavigate()
  const classes = useStyles()
  const { isSubmitting } = useFormikContext()
  const { accountId } = useParams()

  const [buttonType, setButtonType] = useState<'button' | 'submit'>('button')

  const isLastStep = activeStep === maxProgressSteps

  useEffect(() => {
    if (isLastStep) {
      setButtonType('submit')
    } else {
      setButtonType('button')
    }
  }, [isLastStep])

  return (
    <MobileBottomLayout isFixed>
      <Button
        variant="contained"
        onClick={() => navigate(joinAbsRoute(ROUTES.ACCOUNTS, accountId, ROUTES.STEPS))}
        className={`${classes.formButton} ${classes.formButtonDark}`}
      >
        <HelperWrapper t="discard-button-text" isColorInherited />
      </Button>
      <Button
        variant="contained"
        onClick={handlePrevStep}
        className={`${classes.formButton} ${classes.formButtonLight}`}
        disabled={activeStep === minProgressSteps}
      >
        <HelperWrapper t="back-button-text" isColorInherited />
      </Button>
      <Button
        variant="contained"
        onClick={isLastStep ? undefined : handleNextStep}
        className={classes.formButton}
        disabled={isSubmitting}
        type={buttonType}
      >
        {isLastStep ? (
          isSubmitting ? (
            <ButtonProgress />
          ) : (
            <HelperWrapper t="save-button-text" isColorInherited />
          )
        ) : (
          <HelperWrapper t="next-button-text" isColorInherited />
        )}
      </Button>
    </MobileBottomLayout>
  )
}

export { MobileAdditionButtons }
